import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';

export function useStaffUsers() {
  return useQuery({
    queryKey: ['admin-staff-users'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('users')
        .select('id, full_name, email')
        .is('customer_id', null)
        .order('full_name');
      if (error) throw error;
      return data ?? [];
    },
    staleTime: 5 * 60 * 1000,
  });
}
